"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PreferencesIgnoreAndBlock {
    constructor(blockBlackList, blockWhiteList, isBlockBlackListEnabled, isBlockWhiteListEnabled, ignoreBlackList, ignoreWhiteList, isIgnoreBlackListEnabled, isIgnoreWhiteListEnabled, blockedTransactionHashes = []) {
        this.blockBlackList = blockBlackList;
        this.blockWhiteList = blockWhiteList;
        this.isBlockBlackListEnabled = isBlockBlackListEnabled;
        this.isBlockWhiteListEnabled = isBlockWhiteListEnabled;
        this.ignoreBlackList = ignoreBlackList;
        this.ignoreWhiteList = ignoreWhiteList;
        this.isIgnoreBlackListEnabled = isIgnoreBlackListEnabled;
        this.isIgnoreWhiteListEnabled = isIgnoreWhiteListEnabled;
        this.blockedTransactionHashes = blockedTransactionHashes;
    }
}
exports.PreferencesIgnoreAndBlock = PreferencesIgnoreAndBlock;
